import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0048',
    ecrans: ['00-2']
});
